import styled from "styled-components";

import FnrContainedIcon from "UI/FnrContainedIcon";

import { useHeaderTextColor } from "../stateHooks";

const EndingLogo = () => {
  const textColor = useHeaderTextColor();

  return (
    <Center>
      <FnrContainedIcon color={textColor} size="decorative3" icon="uno" />
    </Center>
  );
};

const Center = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;

export default EndingLogo;
